<template>
  <div
      class="rounded-full  relative
                transform cursor-pointer mb-12"
  >
    <router-link :to="'/speaker/' + speaker._id">
      <a>
        <img
            :src="speakerImage"
            class="h-48 w-48 xl:h-64 xl:w-64 object-cover border-4 border-vectric rounded-full mx-auto"
            alt=""
        />
      </a>
    </router-link>
    <div class="flex justify-center">
      <div class="h-6 w-1.5 bg-vectric"></div>
    </div>
    <div class=" flex justify-center">
      <router-link :to="'/speaker/' + speaker._id">
        <a class="bg-black text-white border-vectric border-4 font-semibold uppercase rounded-t-xl rounded-br-xl py-3 px-6 text
          hover:bg-vectric hover:text-white">
          {{ speaker.name }}
        </a>
      </router-link>
    </div>
  </div>
</template>

<script>
import sanityImageBuilder from "../utils/sanityImageBuilder";

export default {
  name: "SpeakerSideBar",
  props: {
    speaker: {
      type: Object,
      required: true
    }
  },
  computed: {
    speakerImage() {
      console.log(this.speaker);
      return sanityImageBuilder
          .image(this.speaker.portrait)
          .width(400)
          .height(400)
          .url();
    },
    speakerLink() {
      return `/speaker/${this.speaker._id}`;
    }
  }
};
</script>

<style scoped></style>
